import { CrisisTeamRole } from '../models/crisis-team-role.model';
import { EmergencyDirectoryContact } from '../models/emergency-directory-contact.model';
import { TeamDocument } from '../models/team-document.model';

export class GetCrisisTeamRoles {
	static readonly type = '[Crisis Team] GetCrisisTeamRoles';
}

export class UpdateCrisisTeamRoles {
	static readonly type = '[Crisis Team] UpdateCrisisTeamRoles';
	constructor(public roles: CrisisTeamRole[]) {}
}

export class GetCrisisTeamRoleAssignments {
	static readonly type = '[Crisis Team] GetCrisisTeamRoleAssignments';
	constructor(public userId: number) {}
}

export class UpdateCrisisTeamRoleAssignments {
	static readonly type = '[Crisis Team] UpdateCrisisTeamRoleAssignments';
	constructor(
		public userId: number,
		public roles: CrisisTeamRole[]
	) {}
}

export class SendMessage {
	static readonly type = '[Crisis Team] SendMessage';
	constructor(
		public subject: string,
		public message: string
	) {}
}

export class ResetAllIndicators {
	static readonly type = '[Crisis Team] ResetAllIndicators';
}

export class GetEmergencyDirectoryContacts {
	static readonly type = '[Crisis Team] GetEmergencyDirectoryContacts';
}

export class UpdateEmergencyDirectoryContacts {
	static readonly type = '[Crisis Team] UpdateEmergencyDirectoryContacts';
	constructor(public contacts: EmergencyDirectoryContact[]) {}
}

export class GetDocuments {
	static readonly type = '[Crisis Team] GetDocuments';
}

export class DownloadDocument {
	static readonly type = '[Crisis Team] DownloadDocument';
	constructor(public doc: TeamDocument) {}
}

export class DeleteDocument {
	static readonly type = '[Crisis Team] DeleteDocument';
	constructor(public doc: TeamDocument) {}
}

export class AddDocument {
	static readonly type = '[Crisis Team] AddDocument';
	constructor(public doc: TeamDocument) {}
}

export class GetTravelStatus {
	static readonly type = '[Crisis Team] GetTravelStatus';
}

export class GetUserDropDowns {
	static readonly type = '[Crisis Team] GetUserDropDowns';
}
